import React from 'react'

class SelectBox extends React.Component {
  render() {
    const {calculateTotalExpenses} = this.props

    return (
      <div className='card card-single total-expenses'>
        <div className='card-body'>
          <div className='row'>
            <div className='col'>
              Total expenses
            </div>
            <div className='col text-right'>
              <strong id='total-expenses'>{calculateTotalExpenses}</strong>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default SelectBox
